/**
 * AUTODOC 평가사 모바일 페이지
 * 경로: /m/eval
 * 
 * 평가사(검차원)가 모바일에서 접속해서:
 * 1. 전화번호+PIN으로 로그인
 * 2. 대기중인 콜 목록 보기
 * 3. 콜 잡기 (선착순)
 * 4. 검차 시작 → 도막/평가/사진/메모 입력 → 검차 완료 제출
 * 5. 내 프로필 (평점, 등급, 리뷰 이력)
 */
import React, { useState, useEffect } from 'react';
import { LogoFull } from './Logo';
import CustomModal from './CustomModal';
import { API_BASE, STATUS, Badge, LvBadge } from './EvalInspectorShared';
import CallDetail from './EvalInspectorCallDetail';
import ProfileView from './EvalInspectorProfile';

// ─── 로그인 화면 ───
function LoginScreen({ onLogin }) {
  var [phone, setPhone] = useState(localStorage.getItem('eval_inspector_phone') || '');
  var [pin, setPin] = useState(localStorage.getItem('eval_inspector_pin') || '');
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 24px', background: '#f8f8f5' }}>
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <LogoFull iconSize={40} fontSize={28} />
        <div style={{ fontSize: 14, color: '#888', marginTop: 4 }}>차량 평가사 전용</div>
      </div>
      <div style={{ background: '#fff', borderRadius: 16, padding: 24, border: '1px solid #eee' }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4, fontWeight: 500 }}>전화번호</label>
          <input value={phone} onChange={function(e) { setPhone(e.target.value.replace(/[^0-9]/g, '')); }} placeholder="01012345678" type="tel"
            style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1.5px solid #e0e0da', borderRadius: 10, fontSize: 16, outline: 'none' }} />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 4, fontWeight: 500 }}>PIN 코드</label>
          <input value={pin} onChange={function(e) { setPin(e.target.value.replace(/[^0-9]/g, '')); }} placeholder="4자리" type="password" maxLength={4}
            style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', border: '1.5px solid #e0e0da', borderRadius: 10, fontSize: 16, outline: 'none', letterSpacing: 8 }} />
        </div>
        <button onClick={function() {
          if (!phone) { setModal({ type: 'danger', title: '실패', message: '전화번호를 입력해주세요', hideCancel: true, onConfirm: closeModal }); return; }
          fetch(API_BASE + '/api/eval/inspectors/login', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone: phone, pin_code: pin }),
          }).then(function(r) { return r.json(); }).then(function(d) {
            if (d.success) {
              localStorage.setItem('eval_inspector_phone', phone);
              localStorage.setItem('eval_inspector_pin', pin);
              localStorage.setItem('eval_inspector_data', JSON.stringify(d.data));
              onLogin(d.data);
            } else setModal({ type: 'danger', title: '실패', message: d.error || '로그인 실패', hideCancel: true, onConfirm: closeModal });
          }).catch(function() { setModal({ type: 'danger', title: '실패', message: '서버 연결 실패', hideCancel: true, onConfirm: closeModal }); });
        }} style={{
          width: '100%', padding: '14px 0', borderRadius: 12, border: 'none',
          background: '#3B8BD4', color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer',
        }}>로그인</button>
      </div>
      <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#aaa' }}>
        관리자에게 계정을 요청하세요
      </div>
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>
  );
}

// ─── Haversine 거리 계산 (km) ───
// Haversine 거리 계산 (km)
var calcDistance = function(lat1, lng1, lat2, lng2) {
  if (!lat1 || !lng1 || !lat2 || !lng2) return null;
  var R = 6371;
  var dLat = (lat2 - lat1) * Math.PI / 180;
  var dLng = (lng2 - lng1) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export default function EvalInspectorPage() {
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };
  var [inspector, setInspector] = useState(null);
  var [orders, setOrders] = useState([]);
  var [myLocation, setMyLocation] = useState(null);
  // Wave W5 (2026-05-21) — GPS 상태 시각 피드백.
  //   'pending' (초기) / 'ok' (위치 수집됨) / 'denied' (권한 거부) / 'error' (GPS off/timeout)
  var [gpsStatus, setGpsStatus] = useState('pending');
  var [gpsUpdatedAt, setGpsUpdatedAt] = useState(null);
  var [tab, setTab] = useState('open');
  var [selectedId, setSelectedId] = useState(null);
  var [showProfile, setShowProfile] = useState(false);
  var [toast, setToast] = useState(null);

  var showToast = function(msg) { setToast(msg); setTimeout(function() { setToast(null); }, 2500); };

  var fetchOrders = function() {
    fetch(API_BASE + '/api/eval/orders').then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) setOrders(d.data || []);
    }).catch(function() {});
  };

  // GPS 위치 가져오기 + 5분마다 서버 업데이트
  useEffect(function() {
    if (!inspector || !navigator.geolocation) return;
    var updateLocation = function() {
      navigator.geolocation.getCurrentPosition(function(pos) {
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;
        setMyLocation({ lat: lat, lng: lng });
        // Wave W5 — 성공 시 상태/시각 갱신
        setGpsStatus('ok');
        setGpsUpdatedAt(new Date());
        fetch(API_BASE + '/api/eval/inspectors/' + inspector.id + '/location', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lat: lat, lng: lng }),
        }).catch(function() {});
      }, function(err) {
        // Wave W5 — 실패 분기 (silent 제거). PERMISSION_DENIED=1, POSITION_UNAVAILABLE=2, TIMEOUT=3
        setGpsStatus(err && err.code === 1 ? 'denied' : 'error');
      }, { enableHighAccuracy: true, timeout: 10000 });
    };
    updateLocation();
    var interval = setInterval(updateLocation, 5 * 60 * 1000);
    return function() { clearInterval(interval); };
  }, [inspector]);

  var handleLogout = function() {
    localStorage.removeItem('eval_inspector_phone');
    localStorage.removeItem('eval_inspector_pin');
    localStorage.removeItem('eval_inspector_data');
    setInspector(null);
    setOrders([]);
  };

  // 자동 로그인
  useEffect(function() {
    var saved = localStorage.getItem('eval_inspector_data');
    if (saved) {
      try { setInspector(JSON.parse(saved)); } catch (e) { localStorage.removeItem('eval_inspector_data'); }
    }
  }, []);

  useEffect(function() { if (inspector) fetchOrders(); }, [inspector]);

  // 브라우저 뒤로가기 연동
  useEffect(function() {
    window.history.replaceState({ evalView: 'list' }, '');
    var handlePop = function(e) {
      var st = e.state;
      if (st && st.evalView === 'list') { setSelectedId(null); setShowProfile(false); }
      else if (st && st.evalView === 'profile') { setSelectedId(null); setShowProfile(true); }
      else if (st && st.evalView === 'detail') { setShowProfile(false); setSelectedId(st.evalDetailId || null); }
      else { setSelectedId(null); setShowProfile(false); window.history.pushState({ evalView: 'list' }, ''); }
    };
    window.addEventListener('popstate', handlePop);
    return function() { window.removeEventListener('popstate', handlePop); };
  }, []);

  var navToView = function(view, detailId) {
    if (view === 'detail') { setSelectedId(detailId); setShowProfile(false); window.history.pushState({ evalView: 'detail', evalDetailId: detailId }, ''); }
    else if (view === 'profile') { setSelectedId(null); setShowProfile(true); window.history.pushState({ evalView: 'profile' }, ''); }
    else { setSelectedId(null); setShowProfile(false); window.history.pushState({ evalView: 'list' }, ''); }
  };

  // 로그인 전
  if (!inspector) return <LoginScreen onLogin={function(data) { setInspector(data); }} />;

  // 거리 계산 + 정렬
  var addDistance = function(list) {
    return list.map(function(o) {
      var dist = myLocation && o.location_lat ? calcDistance(myLocation.lat, myLocation.lng, o.location_lat, o.location_lng) : null;
      return Object.assign({}, o, { _distance: dist });
    }).sort(function(a, b) {
      if (a._distance === null && b._distance === null) return 0;
      if (a._distance === null) return 1;
      if (b._distance === null) return -1;
      return a._distance - b._distance;
    });
  };
  var openCalls = addDistance(orders.filter(function(o) { return o.status === 'open'; }));
  var myCalls = orders.filter(function(o) { return o.inspector_id === inspector.id && ['taken', 'inspecting', 'completed', 'decided', 'rejected'].includes(o.status); });

  // 프로필
  if (showProfile) return (<React.Fragment><ProfileView inspector={inspector} onBack={function() { window.history.back(); }} onLogout={handleLogout} />{modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}</React.Fragment>);

  // 콜 상세
  if (selectedId) {
    var order = orders.find(function(o) { return o.id === selectedId; });
    if (!order) { navToView('list'); return null; }
    return (
      <React.Fragment>
      <CallDetail
        order={order}
        inspector={inspector}
        onBack={function() { window.history.back(); }}
        onTake={function(id) {
          fetch(API_BASE + '/api/eval/orders/' + id + '/take', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ inspector_id: inspector.id }),
          }).then(function() { fetchOrders(); navToView('list'); showToast('콜 수락 완료!'); });
        }}
        onStart={function(id) {
          var doStart = function(lat, lng) {
            fetch(API_BASE + '/api/eval/orders/' + id + '/start', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ start_lat: lat || null, start_lng: lng || null }),
            }).then(function() { fetchOrders(); });
          };
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(pos) { doStart(pos.coords.latitude, pos.coords.longitude); }, function() { doStart(null, null); }, { enableHighAccuracy: true });
          } else { doStart(null, null); }
        }}
        onComplete={function(id, data) {
          var uploadPhotos = function(orderId, photos) {
            var allFiles = [];
            Object.keys(photos).forEach(function(category) {
              var photoList = photos[category] || [];
              photoList.forEach(function(photo) {
                if (!photo.file) return;
                allFiles.push({ file: photo.file, category: category, memo: photo.memo || '' });
              });
            });
            var uploaded = 0;
            var total = allFiles.length;
            if (total > 0) showToast('사진 업로드 중... 0/' + total);
            var chain = Promise.resolve();
            allFiles.forEach(function(item) {
              chain = chain.then(function() {
                var formData = new FormData();
                formData.append('photos', item.file);
                formData.append('category', item.category);
                formData.append('memo', item.memo);
                return fetch(API_BASE + '/api/eval/orders/' + orderId + '/photos', { method: 'POST', body: formData }).then(function() {
                  uploaded++;
                  showToast('사진 업로드 중... ' + uploaded + '/' + total);
                });
              });
            });
            return chain;
          };

          var doComplete = function(endLat, endLng) {
            var photoData = data.photos;
            var photoPromise = (photoData && typeof photoData === 'object' && Object.keys(photoData).length > 0 && !Array.isArray(photoData))
              ? uploadPhotos(id, photoData) : Promise.resolve();
            photoPromise.then(function() {
              return fetch(API_BASE + '/api/eval/orders/' + id + '/complete', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  paint_hood: data.paint_hood, paint_roof: data.paint_roof,
                  paint_fender_l: data.paint_fender_l, paint_fender_r: data.paint_fender_r,
                  paint_door_fl: data.paint_door_fl, paint_door_fr: data.paint_door_fr,
                  paint_door_rl: data.paint_door_rl, paint_door_rr: data.paint_door_rr,
                  score_exterior: data.score_exterior, score_interior: data.score_interior,
                  score_engine: data.score_engine, score_undercarriage: data.score_undercarriage,
                  score_overall: data.score_overall,
                  damage_data: data.damage_data || {},
                  inspector_notes: data.inspector_notes || '',
                  end_lat: endLat || null, end_lng: endLng || null,
                }),
              });
            }).then(function(r) { return r.json(); }).then(function(d) { if(d.success){fetchOrders();navToView('list');showToast('검차 완료 제출!')}else{setModal({type:'danger',title:'실패',message:'검차 완료 실패: '+(d.error||'서버 오류'),hideCancel:true,onConfirm:closeModal})} }).catch(function(e) { setModal({type:'danger',title:'실패',message:'검차 완료 오류: '+e.message,hideCancel:true,onConfirm:closeModal}); });
          };

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(pos) { doComplete(pos.coords.latitude, pos.coords.longitude); }, function() { doComplete(null, null); }, { enableHighAccuracy: true });
          } else { doComplete(null, null); }
        }}
      />
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
      </React.Fragment>
    );
  }

  // 메인 화면
  return (
    <div style={{ minHeight: '100vh', background: '#f8f8f5' }}>
      {/* 토스트 */}
      {toast && (
        <div style={{
          position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
          background: '#1D9E75', color: '#fff', padding: '10px 24px',
          borderRadius: 10, fontSize: 14, fontWeight: 600, zIndex: 999,
        }}>{toast}</div>
      )}

      {/* 헤더 - 프로필 */}
      <div onClick={function() { navToView('profile'); }} style={{
        padding: '16px 16px 12px', display: 'flex', alignItems: 'center', gap: 10,
        cursor: 'pointer', background: '#fff', borderBottom: '1px solid #eee',
      }}>
        <div style={{
          width: 42, height: 42, borderRadius: '50%',
          background: inspector.avg_rating >= 4.5 ? '#FAECE7' : '#EEEDFE',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 18, fontWeight: 700,
          color: inspector.avg_rating >= 4.5 ? '#D85A30' : '#534AB7',
        }}>{inspector.name[0]}</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: '#111' }}>{inspector.name}</span>
            <LvBadge level={inspector.level} />
          </div>
          <div style={{ fontSize: 12, color: '#888' }}>{inspector.area} · {inspector.avg_rating}★ · {inspector.total_jobs}건</div>
        </div>
        <span style={{ fontSize: 12, color: '#3B8BD4', fontWeight: 500 }}>프로필 →</span>
      </div>

      {/* Wave W5 (2026-05-21) — GPS 상태 시각 indicator. 콜 거리 정렬 동작 여부 가시화. */}
      <div style={{ background: '#fff', padding: '8px 14px', borderBottom: '1px solid #eee', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {gpsStatus === 'ok' && (
          <span style={{ color: '#1D9E75', fontWeight: 600 }}>
            📡 위치 활성 {gpsUpdatedAt ? '(' + gpsUpdatedAt.getHours().toString().padStart(2,'0') + ':' + gpsUpdatedAt.getMinutes().toString().padStart(2,'0') + ' 갱신)' : ''}
          </span>
        )}
        {gpsStatus === 'pending' && (
          <span style={{ color: '#888' }}>🔄 GPS 위치 확인 중...</span>
        )}
        {gpsStatus === 'denied' && (
          <span style={{ color: '#A32D2D', fontWeight: 600 }}>⚠ 위치 권한 거부 — 거리 정렬 비활성</span>
        )}
        {gpsStatus === 'error' && (
          <span style={{ color: '#D85A30', fontWeight: 600 }}>⚠ GPS 오류 — 위치 켜고 새로고침</span>
        )}
      </div>

      {/* 탭 */}
      <div style={{ display: 'flex', background: '#fff', borderBottom: '1px solid #eee' }}>
        {[['open', '콜 대기 ('+openCalls.length+')'], ['mine', '내 검차 ('+myCalls.length+')'], ['schedule', '내 일정']].map(function(item) { var k=item[0], label=item[1]; return (
          <button key={k} onClick={function() { setTab(k); }} style={{
            flex: 1, padding: '12px 0', border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: tab === k ? 700 : 400,
            color: tab === k ? '#3B8BD4' : '#888',
            background: 'transparent',
            borderBottom: tab === k ? '2.5px solid #3B8BD4' : '2.5px solid transparent',
            WebkitTapHighlightColor: 'transparent',
          }}>{label}</button>
        ); })}
      </div>

      {/* 콜 목록 */}
      {tab !== 'schedule' && (
      <div style={{ padding: '12px 16px' }}>
        {(tab === 'open' ? openCalls : myCalls).length === 0 && (
          <div style={{ textAlign: 'center', padding: '48px 0', color: '#aaa', fontSize: 14 }}>
            {tab === 'open' ? '대기중인 콜이 없습니다' : '진행중인 검차가 없습니다'}
          </div>
        )}
        {(tab === 'open' ? openCalls : myCalls).map(function(o) { return (
          <div key={o.id} onClick={function() { navToView('detail', o.id); }} style={{
            background: '#fff', borderRadius: 14, border: '1px solid #eee',
            padding: 14, marginBottom: 8, cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#111' }}>{o.car_model}</span>
              {tab === 'open'
                ? <span style={{ fontSize: 14, fontWeight: 700, color: '#1D9E75' }}>{(o.fee || 0).toLocaleString()}원</span>
                : <Badge status={o.status} />
              }
            </div>
            <div style={{ fontSize: 13, color: '#888' }}>{o.car_detail} · {o.car_year}년</div>
            <div style={{ fontSize: 12, color: '#3B8BD4', marginTop: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{o.location}</span>
              <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                {o._distance != null && <span style={{ color: '#D85A30', fontWeight: 700, fontSize: 12 }}>{o._distance < 1 ? (o._distance * 1000).toFixed(0) + 'm' : o._distance.toFixed(1) + 'km'}</span>}
                <span style={{ color: '#aaa' }}>{o.inspect_date} {o.inspect_time}</span>
              </span>
            </div>
          </div>
        ); })}
      </div>
      )}

      {/* 내 일정 캘린더 */}
      {tab === 'schedule' && (function() {
        var DAY_NAMES = ['일','월','화','수','목','금','토'];
        var today = new Date(); today.setHours(0,0,0,0);
        var todayStr = today.getFullYear()+'-'+String(today.getMonth()+1).padStart(2,'0')+'-'+String(today.getDate()).padStart(2,'0');

        // 내 오더만 (배정된 것)
        var myAllOrders = orders.filter(function(o) { return o.inspector_id === inspector.id; });

        // 날짜별 그룹핑
        var byDate = {};
        myAllOrders.forEach(function(o) {
          var d = o.inspect_date || (o.created_at ? o.created_at.substring(0,10) : '');
          if (!d) return;
          if (!byDate[d]) byDate[d] = [];
          byDate[d].push(o);
        });

        // 주간 날짜 계산
        var weekOffset = 0;
        var getWeekDays = function() {
          var start = new Date(today);
          var day = start.getDay();
          start.setDate(start.getDate() - (day === 0 ? 6 : day - 1) + weekOffset * 7);
          var days = [];
          for (var i = 0; i < 7; i++) {
            var d = new Date(start);
            d.setDate(start.getDate() + i);
            days.push(d);
          }
          return days;
        };
        var weekDays = getWeekDays();

        // 오늘 오더
        var todayOrders = byDate[todayStr] || [];

        return (
          <div style={{ padding: '12px 16px' }}>
            {/* 오늘 요약 */}
            {todayOrders.length > 0 && (
              <div style={{ background: '#E6F1FB', borderRadius: 12, padding: '10px 14px', marginBottom: 12, border: '1px solid #B5D4F4' }}>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#185FA5' }}>오늘 검차 {todayOrders.length}건</span>
                <span style={{ fontSize: 12, color: '#3B8BD4', marginLeft: 8 }}>
                  {todayOrders.map(function(o) { return o.car_model.split(' ')[0] + ' ' + (o.inspect_time || ''); }).join(', ')}
                </span>
              </div>
            )}
            {todayOrders.length === 0 && (
              <div style={{ background: '#f8f8f5', borderRadius: 12, padding: '10px 14px', marginBottom: 12, textAlign: 'center', color: '#aaa', fontSize: 13 }}>오늘 예정된 검차가 없습니다</div>
            )}

            {/* 주간 캘린더 */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4, marginBottom: 14 }}>
              {weekDays.map(function(date, i) {
                var key = date.getFullYear()+'-'+String(date.getMonth()+1).padStart(2,'0')+'-'+String(date.getDate()).padStart(2,'0');
                var dayOrders = byDate[key] || [];
                var isToday = key === todayStr;
                var isWeekend = date.getDay() === 0 || date.getDay() === 6;
                return (
                  <div key={i} style={{
                    padding: '6px 2px', borderRadius: 10, minHeight: 80, cursor: 'pointer',
                    background: isToday ? '#FAEEDA' : '#fff',
                    border: isToday ? '1.5px solid #EF9F27' : '1px solid #eee',
                    WebkitTapHighlightColor: 'transparent',
                  }}>
                    <div style={{ textAlign: 'center', marginBottom: 4 }}>
                      <div style={{ fontSize: 10, color: isWeekend ? '#E24B4A' : '#aaa' }}>{DAY_NAMES[date.getDay()]}</div>
                      <div style={{ fontSize: 15, fontWeight: isToday ? 800 : 600, color: isToday ? '#BA7517' : isWeekend ? '#E24B4A' : '#222' }}>{date.getDate()}</div>
                    </div>
                    {dayOrders.slice(0,2).map(function(o) {
                      var st = STATUS[o.status] || STATUS.open;
                      return (
                        <div key={o.id} onClick={function(e) { e.stopPropagation(); navToView('detail', o.id); }} style={{
                          fontSize: 8, padding: '2px 3px', borderRadius: 4, marginBottom: 2,
                          background: st.bg, color: st.color, fontWeight: 600,
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        }}>{(o.inspect_time||'').substring(0,2)} {(o.car_model||'').split(' ')[0].substring(0,4)}</div>
                      );
                    })}
                    {dayOrders.length > 2 && <div style={{ fontSize: 8, color: '#888', textAlign: 'center' }}>+{dayOrders.length-2}</div>}
                  </div>
                );
              })}
            </div>

            {/* 전체 일정 목록 (날짜순) */}
            <div style={{ fontSize: 14, fontWeight: 700, color: '#222', marginBottom: 8 }}>배정된 검차 ({myAllOrders.length}건)</div>
            {myAllOrders.length === 0 && <div style={{ textAlign: 'center', padding: '30px 0', color: '#aaa', fontSize: 13 }}>배정된 검차가 없습니다</div>}
            {myAllOrders.sort(function(a,b) { return (a.inspect_date||'').localeCompare(b.inspect_date||''); }).map(function(o) {
              var st = STATUS[o.status] || STATUS.open;
              return (
                <div key={o.id} onClick={function() { navToView('detail', o.id); }} style={{
                  background: '#fff', borderRadius: 12, border: '1px solid #eee',
                  padding: '10px 14px', marginBottom: 6, cursor: 'pointer',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: '#111' }}>{o.car_model}</span>
                    <Badge status={o.status} />
                  </div>
                  <div style={{ fontSize: 12, color: '#888', display: 'flex', gap: 8 }}>
                    <span>{o.inspect_date} {o.inspect_time}</span>
                    <span>{o.location}</span>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })()}
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>
  );
}
